var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 76,
    viewBox: "0 0 92 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddi_1647_166634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1647_166634",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 24.0015,
    width: 52,
    height: 32,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20,
    y: 24.0015,
    width: 52,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.25 51.4008C48.872 53.6456 52.2777 55.0015 56 55.0015C64.2843 55.0015 71 48.2857 71 40.0015C71 31.7172 64.2843 25.0015 56 25.0015C52.2777 25.0015 48.872 26.3573 46.25 28.6021C43.628 26.3573 40.2223 25.0015 36.5 25.0015C28.2157 25.0015 21.5 31.7172 21.5 40.0015C21.5 48.2857 28.2157 55.0015 36.5 55.0015C40.2223 55.0015 43.628 53.6456 46.25 51.4008Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.25 51.4008C48.872 53.6456 52.2777 55.0015 56 55.0015C64.2843 55.0015 71 48.2857 71 40.0015C71 31.7172 64.2843 25.0015 56 25.0015C52.2777 25.0015 48.872 26.3573 46.25 28.6021C43.628 26.3573 40.2223 25.0015 36.5 25.0015C28.2157 25.0015 21.5 31.7172 21.5 40.0015C21.5 48.2857 28.2157 55.0015 36.5 55.0015C40.2223 55.0015 43.628 53.6456 46.25 51.4008Z",
    fill: "url(#paint0_linear_1647_166634)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.25 51.4008C48.872 53.6456 52.2777 55.0015 56 55.0015C64.2843 55.0015 71 48.2857 71 40.0015C71 31.7172 64.2843 25.0015 56 25.0015C52.2777 25.0015 48.872 26.3573 46.25 28.6021C43.628 26.3573 40.2223 25.0015 36.5 25.0015C28.2157 25.0015 21.5 31.7172 21.5 40.0015C21.5 48.2857 28.2157 55.0015 36.5 55.0015C40.2223 55.0015 43.628 53.6456 46.25 51.4008Z",
    fill: "#D7E3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 55.0015V56.0015V55.0015ZM46.25 51.4008L45.5997 50.6412L46.25 50.0844L46.9003 50.6412L46.25 51.4008ZM46.25 28.6021L46.9003 29.3617L46.25 29.9185L45.5997 29.3617L46.25 28.6021ZM56 56.0015C52.0303 56.0015 48.396 54.5545 45.5997 52.1605L46.9003 50.6412C49.3481 52.7367 52.5251 54.0015 56 54.0015V56.0015ZM72 40.0015C72 48.838 64.8366 56.0015 56 56.0015V54.0015C63.732 54.0015 70 47.7334 70 40.0015H72ZM56 24.0015C64.8366 24.0015 72 31.1649 72 40.0015H70C70 32.2695 63.732 26.0015 56 26.0015V24.0015ZM45.5997 27.8424C48.396 25.4484 52.0303 24.0015 56 24.0015V26.0015C52.5251 26.0015 49.3481 27.2662 46.9003 29.3617L45.5997 27.8424ZM36.5 24.0015C40.4697 24.0015 44.104 25.4484 46.9003 27.8424L45.5997 29.3617C43.1519 27.2662 39.9749 26.0015 36.5 26.0015V24.0015ZM20.5 40.0015C20.5 31.1649 27.6634 24.0015 36.5 24.0015V26.0015C28.768 26.0015 22.5 32.2695 22.5 40.0015H20.5ZM36.5 56.0015C27.6634 56.0015 20.5 48.838 20.5 40.0015H22.5C22.5 47.7335 28.768 54.0015 36.5 54.0015V56.0015ZM46.9003 52.1605C44.104 54.5545 40.4697 56.0015 36.5 56.0015V54.0015C39.9749 54.0015 43.1519 52.7367 45.5997 50.6412L46.9003 52.1605Z",
    fill: "url(#paint1_linear_1647_166634)",
    mask: "url(#path-1-outside-1_1647_166634)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_dddi_1647_166634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_1647_166634",
    maskUnits: "userSpaceOnUse",
    x: 39.5,
    y: 26.6021,
    width: 13,
    height: 27,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39.5,
    y: 26.6021,
    width: 13,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.25 28.6021C49.4635 31.3532 51.5 35.4395 51.5 40.0014C51.5 44.5634 49.4635 48.6497 46.25 51.4008C43.0365 48.6497 41 44.5634 41 40.0014C41 35.4395 43.0365 31.3532 46.25 28.6021Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.25 28.6021C49.4635 31.3532 51.5 35.4395 51.5 40.0014C51.5 44.5634 49.4635 48.6497 46.25 51.4008C43.0365 48.6497 41 44.5634 41 40.0014C41 35.4395 43.0365 31.3532 46.25 28.6021Z",
    fill: "url(#paint2_linear_1647_166634)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.25 28.6021L45.5997 27.8424L46.25 27.2856L46.9003 27.8424L46.25 28.6021ZM46.25 51.4008L46.9003 52.1604L46.25 52.7172L45.5997 52.1604L46.25 51.4008ZM46.9003 27.8424C50.3263 30.7754 52.5 35.1351 52.5 40.0014H50.5C50.5 35.7438 48.6007 31.9309 45.5997 29.3617L46.9003 27.8424ZM52.5 40.0014C52.5 44.8678 50.3263 49.2274 46.9003 52.1604L45.5997 50.6412C48.6007 48.0719 50.5 44.259 50.5 40.0014H52.5ZM45.5997 52.1604C42.1737 49.2274 40 44.8678 40 40.0014H42C42 44.259 43.8993 48.0719 46.9003 50.6412L45.5997 52.1604ZM40 40.0014C40 35.1351 42.1737 30.7754 45.5997 27.8424L46.9003 29.3617C43.8993 31.9309 42 35.7438 42 40.0014H40Z",
    fill: "url(#paint3_radial_1647_166634)",
    mask: "url(#path-3-outside-2_1647_166634)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddi_1647_166634",
    x: 0.5,
    y: 6.00146,
    width: 91,
    height: 69.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.239843 0 0 0 0 0.396078 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1647_166634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.180392 0 0 0 0 0.396078 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1647_166634",
    result: "effect2_dropShadow_1647_166634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1647_166634",
    result: "effect3_dropShadow_1647_166634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1647_166634",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.5,
    dy: -1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_1647_166634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddi_1647_166634",
    x: 10,
    y: 0.285645,
    width: 62,
    height: 71.9316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.180392 0 0 0 0 0.396078 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1647_166634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.180392 0 0 0 0 0.396078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1647_166634",
    result: "effect2_dropShadow_1647_166634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1647_166634",
    result: "effect3_dropShadow_1647_166634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1647_166634",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.5,
    dy: -1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_1647_166634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1647_166634",
    x1: 15.7545,
    y1: 3.5729,
    x2: 40.4828,
    y2: 68.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265158,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1647_166634",
    x1: 22,
    y1: 33.0015,
    x2: 92.682,
    y2: 60.5715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B80A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1647_166634",
    x1: 39.7812,
    y1: 12.3172,
    x2: 66.645,
    y2: 31.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265158,
    stopColor: "#E8EFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F0F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1647_166634",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 39.0014) rotate(180) scale(15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6681A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.671e0260a37a6c65a865957c13b12776.svg";
export { ForwardRef as ReactComponent };